import React, { useState, useEffect } from 'react';
import supabase from '../../../supabase/supabase';
import { FiSearch, FiCode } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const PaymentLogViewer = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    const { data } = await supabase.from('payment_logs').select('*').order('created_at', { ascending: false }).limit(50);
    if (data) setLogs(data);
    setLoading(false);
  };

  const toggleExpand = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  if (loading) return <div className="p-4 text-gray-500">Loading logs...</div>;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50">
        <h3 className="text-lg font-serif text-gray-800">System Logs</h3>
        <button onClick={fetchLogs} className="text-xs font-bold text-brand-darkSage hover:text-brand-gold uppercase tracking-wider">Refresh</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-100">
            <tr>
              <th className="p-4">Timestamp</th>
              <th className="p-4">Endpoint / Action</th>
              <th className="p-4">Reference</th>
              <th className="p-4">Status</th>
              <th className="p-4 text-right">Inspect</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {logs.map(log => (
              <React.Fragment key={log.id}>
                <tr className="hover:bg-gray-50/50">
                  <td className="p-4 text-gray-500 text-xs">{new Date(log.created_at).toLocaleString()}</td>
                  <td className="p-4 font-medium text-gray-800">{log.endpoint} <span className="text-[10px] bg-gray-100 px-2 py-0.5 rounded ml-2">{log.action_type}</span></td>
                  <td className="p-4 font-mono text-xs">{log.transaction_reference || 'N/A'}</td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded text-xs font-bold ${log.status_code >= 400 ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                      {log.status_code}
                    </span>
                  </td>
                  <td className="p-4 text-right">
                    <button onClick={() => toggleExpand(log.id)} className="text-gray-400 hover:text-brand-gold p-1">
                      <SafeIcon icon={FiCode} />
                    </button>
                  </td>
                </tr>
                {expanded[log.id] && (
                  <tr>
                    <td colSpan="5" className="p-0 border-b border-gray-100">
                      <div className="bg-[#1e1e1e] p-4 text-xs font-mono text-green-400 overflow-x-auto">
                        <div className="mb-2"><strong className="text-white">Request:</strong><br/>{JSON.stringify(log.request_payload, null, 2)}</div>
                        <div><strong className="text-white">Response:</strong><br/>{JSON.stringify(log.response_payload, null, 2)}</div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentLogViewer;